import { render, staticRenderFns } from "./MicrosoftSignInButton.vue?vue&type=template&id=306b8023&scoped=true&"
import script from "./MicrosoftSignInButton.vue?vue&type=script&lang=js&"
export * from "./MicrosoftSignInButton.vue?vue&type=script&lang=js&"
import style0 from "./MicrosoftSignInButton.vue?vue&type=style&index=0&id=306b8023&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b8023",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
